{{#if label}}
  {{#> elements/_dt}}
      {{> elements/_label }}
  {{/elements/_dt}}
{{/if}}
<dd>
  <input id="{{name}}_{{value}}" type="checkbox" name="{{prefix}}[{{name}}][]" value="{{value}}">
  <label for="{{name}}_{{value}}">{{text}}</label>
</dd>
